// extracted by mini-css-extract-plugin
export default {"footer":"Footer__footer--3Mr","withOutHeader":"Footer__withOutHeader--1RC"};